import Head from 'next/head';
import { useEffect } from 'react';

import ConfirmForm from 'components/forms/list-price-form/ConfirmForm';
import ListPriceTemplate from 'components/forms/list-price-form/ListPriceTemplate';
import PriceForm from 'components/forms/list-price-form/PriceForm';
import SignUpForm from 'components/forms/sign-up-form';
import AuthLayout from 'components/layout/auth-layout';
import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import { resetOnboarding } from 'store/slices/onboarding';
import { onboardingSelector } from 'store/slices/onboarding/selector';

function SignUpPage() {
  const { step } = useAppSelector(onboardingSelector);
  const dispatch = useAppDispatch();

  useEffect(
    () => () => {
      dispatch(resetOnboarding());
    },
    [dispatch]
  );

  return (
    <AuthLayout>
      <Head>
        <title>Sign-Up</title>
      </Head>
      {step === 'stepUser' && <SignUpForm />}
      {step === 'stepListPrice' && (
        <ListPriceTemplate>
          <PriceForm />
        </ListPriceTemplate>
      )}
      {step === 'stepConfirm' && (
        <ListPriceTemplate lastStep>
          <ConfirmForm />
        </ListPriceTemplate>
      )}
    </AuthLayout>
  );
}

export default SignUpPage;
